<template>
    <div class="body">
        <p class="font1" style="padding-top: 12vh;"><span class="font1" style="font-size: 1.2rem;">{{ ReportData.stuname }}</span>老师：</p>
        <p class="font1" style="padding-top: 2vh;">《东坡梦》有云：得遇良师，三生有幸。</p>
        <p class="font1" style="padding-top: 2vh;">您是传道授业的人，传承薪火，躬耕桃李，成就了我们生生不息的春天。</p>
        <p class="font1" style="padding-top: 2vh;">青衿志高，不忘师恩迢迢。</p>
        <p class="font1" style="padding-top: 2vh;">值此教师节之际，祝您节日快乐！</p>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
    data() {
        return {   
            
        }
    },
    created() {
    
    }
}
</script>
  
<style scoped>       
.body {
    background: 
                url("../../assets/logo1.png") left  top  no-repeat,
                /* url("../../assets//24August/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/teacherDay/bg.jpg")  no-repeat;
    background-size: 110px 40px,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 90%;
    /* padding-left: 8%; */
    margin: 0 auto;
    text-align: justify;
    font-size: 18px;
    color: #fff;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #654727;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>